import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { createBrowserHistory } from "history";
// import ProtectedRoute from "hocs/ProtectedRoute/ProtectedRoute";

// core components
import AutoLogin from "views/pages/AutoLogin";
import GoldRates from "views/pages/GoldRates";
import GoldRatesCreate from "views/pages/GoldRatesCreate";
import StateMaster from "views/pages/State/StateMaster";
import StateMasterCreate from "views/pages/State/StateMasterCreate";
import Branches from "views/pages/Branches";
import BranchCreate from "views/pages/BranchCreate";
import Pincodes from "views/pages/Pincodes";
import PincodeCreate from "views/pages/PincodeCreate";
import User from "views/pages/user";
import UserInvite from "views/pages/UserInvite";
import Roles from "views/pages/Roles/Roles";
import RoleCreate from "views/pages/Roles/RoleCreate";
import Structure from "views/pages/Structure/Structure";
import StructureCreate from "views/pages/Structure/StructureCreate";
import Hierarchy from "views/pages/Hierarchy/Hierarchy";
import HierarchyCreate from "views/pages/Hierarchy/HierarchyCreate";
import Scheme from "views/pages/Scheme";
import SchemeCreate from "views/pages/SchemeCreate";
import Dashboard from "views/admin/pages/Dashboard";
import MainContainer from "./components/UpdateUi/MainContainer"
import { withStyles } from "@material-ui/core";
import brandTheme from "brandTheme/Theme";
import Ornament from "views/pages/Ornament/Ornament";
import OrnamentCreate from "views/pages/Ornament/OrnamentCreate";
import StandardDeduction from "views/pages/StandardDeduction/StandardDeduction";
import StandardDeductionCreate from "views/pages/StandardDeduction/StandardDeductionCreate";
import NoticeBoard from "views/pages/NoticeBoard/NoticeBoard";
import NoticeBoardCreate from "views/pages/NoticeBoard/NoticeBoardCreate";
import Register from "views/pages/Register/Register";
import RegisterCreate from "views/pages/Register/RegisterCreate";
import PacketInventory from "views/pages/PacketInventory/packetInventory";
import Lender from "views/pages/Lender/Lender";
import LenderCreate from "views/pages/Lender/LenderCreate";
import BlackListPinCodes from "views/pages/BlackListPincodes/BlackListPincodes";
import BlackListPinCodesCreate from "views/pages/BlackListPincodes/BlackLisPincodesCreate";
import RuleEngineWeighage from "views/pages/RuleEngineWeighage/RuleEngineWeighage";
import RelationShipMaster from "views/pages/RelationShipMaster/RelationShipMaster";
import RelationShipMasterCreate from "views/pages/RelationShipMaster/RelationShipMasterCreate";
import NegativeProfileMaster from "views/pages/NegativeProfileMaster/NegativeProfileMaster";
import NegativeProfileMasterCreate from "views/pages/NegativeProfileMaster/NegativeProfileCreate";
import DiscrepancyMaster from "views/pages/DiscrepancyMaster/DiscrepancyMaster";
import DiscrepancyMasterCreate from "views/pages/DiscrepancyMaster/DiscrepancyMasterCreate";
import CollateralEvaluationMaster from "views/pages/CollateralEvaluationMaster/CollateralEvaluationMaster";
import CollateralEvaluationMasterCreate from "views/pages/CollateralEvaluationMaster/CollateralEvaluationMasterCreate";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import RiskCategoryMaster from "views/pages/RiskCategoriesMaster/RiskCategoryMaster";
import RiskCategoryMasterCreate from "views/pages/RiskCategoriesMaster/RiskCategoryMasterCreate";
import RiskCategoryScoreMaster from "views/pages/RiskCategoryScoreMaster/RiskCategoryScoreMaster";
import RiskCategoryScoreMasterCreate from "views/pages/RiskCategoryScoreMaster/RiskCategoryScoreMasterCreate";
import RiskCategoryTab from "views/pages/RiskCategoriesMaster/RiskCategoryTabs";
import RiskWeightageCreate from "views/pages/RiskCategoriesMaster/RiskWeightageCreate";
import InsuredEligibility from "views/pages/InsuredEligibility/InsuredEligibility";
import InsuredEligibilityCreate from "views/pages/InsuredEligibility/InsuredEligibilityCreate";
import SumInsured from "views/pages/SumInsured/SumInsured";
import SumInsuredCreate from "views/pages/SumInsured/SumInsuredCreate";
import ThirdParty from "views/pages/ThirdPartyMaster/ThirdParty";
import ThirdPartyCreate from "views/pages/ThirdPartyMaster/ThirdPartyCreate";
import HolidayMaster from "views/pages/HolidayMaster/HolidayMaster";
import HolidayMasterCreate from "views/pages/HolidayMaster/HolidayMasterCreate";
import GlHeadMaster from "views/pages/GlHeadMaster/GlHeadMaster";
import GlHeadCreate from "views/pages/GlHeadMaster/GlHeadMasterCreate";
import GlHeadEdit from "views/pages/GlHeadMaster/GlHeadMasterEdit";
import WhiteListIPMaster from "views/pages/WhiteListIpMaster/WhiteListIPMaster";
import WhiteListIPMasterCreate from "views/pages/WhiteListIpMaster/WhiteListIPMasterCreate";
import AccessRestriction from "views/pages/AccessRestriction/AccessRestriction";
import AccessRestrictionCreate from "views/pages/AccessRestriction/AccessRestrictionCreate";
import AccessRestrictionTabs from "views/pages/AccessRestriction/AccessRestrictionTabs";
import Partner from "views/pages/Partner/Partner";
import PartnerCreate from "views/pages/Partner/PartnerCreate";
import PartnerDeal from "views/pages/PartnerDeal/PartnerDeal";
import PartnerDealCreate from "views/pages/PartnerDeal/PartnerDealCreate";
import PartnerDealShare from "views/pages/PartnerDealShare/PartnerDealShare";
import PartnerDealShareCreate from "views/pages/PartnerDealShare/PartnerDealShareCreate";
import RenewalTopUpValidation from "views/pages/RenewalTopUPValidation/RenewalTopUpValidation";
import RenewalTopUpValidationCreate from "views/pages/RenewalTopUPValidation/RenewalTopUpValidationCreate";
import Designation from "views/pages/Designation/Designation";
import DesignationCreate from "views/pages/Designation/DesignationCreate";
import DeviationCreate from "views/pages/DeviationMaster/DeviationCreate";
import Deviation from "views/pages/DeviationMaster/Deviation";
import LeadValidation from "views/pages/LeadValidation/LeadValidation";
import LeadValidationCreate from "views/pages/LeadValidation/LeadValidationCreate";
import NegativeRegisteryMasterCreate from "views/pages/NegativeRegisteryMaster/NegativeRegisteryCreate";
import NegativeRegisteryMaster from "views/pages/NegativeRegisteryMaster/NegtaiveRegisteryMaster";
import MasterCategoryCreate from "views/pages/MasterCreate/MasterCategory/MasterCategoryCreate";
import MasterItemCreate from "views/pages/MasterCreate/MasterItem/MasterItemCreate";
import MasterItem from "views/pages/MasterCreate/MasterItem/MasterItem";
import MasterCategory from "views/pages/MasterCreate/MasterCategory/MasterCategory";
import FoirConfig from "views/pages/FoirConfig/FoirConfig";
import FoirConfigCreate from "views/pages/FoirConfig/FoiConfigCreate";
import DiamondMaster from "views/pages/DiamondMaster/DiamondMaster";
import DiamondMasterCreate from "views/pages/DiamondMaster/DiamondMasterCreate";
import SilverMaster from "views/pages/SilverMaster/SilverMaster";
import SilverMasterCreate from "views/pages/SilverMaster/SilverMasterCreate";

const hist = createBrowserHistory();

const style = () => ({
  inputFieldContainer: {
    maxWidth: "1050px",
    margin: "0 auto",
  },
  fieldContaienr:{
    margin: "2% 2% 0px 2%",
    maxWidth: "28%",
    "@media (max-width: 768px)": {
      maxWidth:'46%',
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth:'100%',
    },
  },
  header: {
    fontSize: brandTheme.innerHeaderFontSize,
    fontWeight: 700,
    lineHeight: "1.5rem",
    fontFamily: brandTheme.font.poppins,
    margin: "1% 2% 0px 2%",
  },
  inputContainer:{
    height:'75vh',
    overflowY:'auto',
    '@media only screen and (max-width: 600px)': {
        height:'60vh',
    },
  },
  button: {
    backgroundColor: brandTheme.buttonColor,
    color: brandTheme.white,
    borderRadius: "10px",
    padding: "10px 15px",
    minWidth: "140px",
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },
  button2: {
    minWidth: "140px",
    borderRadius: "10px",
    padding: "10px 15px",
    backgroundColor: brandTheme.button2Color,
    color:brandTheme.white,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },
  buttonContainer:{
    marginLeft:'20px'
  },
  chargeContainer:{
    display:'flex',
    justifyContent:'space-between',
    marginRight:'6%',
  },
  deductionContainer:{
    display:'flex',
    justifyContent:'end',
    marginRight:'13%',
  },
  buttonDelContainer:{
    textAlign:'right',
    marginRight:'6%',
    marginTop:"10px"
  },
  bottomText:{
    marginLeft: "15%",
    maxWidth: "100%",
    color: brandTheme.red,
    marginTop:"1%",
    fontWeight: "400",
    fontStyle: "italic",
    fontSize: "18px",
  },
  leftButtonScheme: {
    width: "93%",
    textAlign: "right",
    marginTop: "25px",
    marginBottom: "10px",
  },
  schemeButton:{
    marginRight:"10px",
  },
  container:{
    '& .react-calendar':{
    width:'100% !important',
    },
    '& .react-calendar__tile--active':{
    background:'white',
    color:'black',
    },
    '& .react-calendar_month-viewdays_day--weekend':{
    color:'red'
    }
    },
    holidayDate:{
      color: '#1F880D !important',
      fontWeight: 'bold', 
    },
  calendarHeader:{
    textAlign: 'center',
    border: '1px solid #a0a096',
    width: '99.5%',
    marginBottom: '0px',
    borderBottom: '0',
  }
})
const updateFavicon = (newFavicon) => {
  console.log(newFavicon,"data111")

  const favicon = document.getElementById('dynamic-favicon');
  if (favicon) {
    favicon.href = newFavicon;
  } else {
    const link = document.createElement('link');
    link.id = 'dynamic-favicon';
    link.rel = 'shortcut icon';
    link.href = newFavicon;
    document.head.appendChild(link);
  }
};
const App=({ classes })=> {
  const [featureFlagState, setFeatureFlagState]= useState({})
  useEffect(() => {
    getFeatureFlag();
  }, []);
  const getFeatureFlag = async () => {
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
    });
    updateFavicon(result?.data?.faviconUrl);
    setFeatureFlagState(result?.data)
  };
  return (
    <BrowserRouter history={hist}>
      <Routes>
        <Route path="/auto/:autoId" element={<AutoLogin />} />
        <Route path="/coreservice" element={<MainContainer featureFlagState={featureFlagState}/>}>
          <Route path="dashboard" element={<Dashboard/>}/>
          <Route path="gold-rates" element={<GoldRates featureFlagState={featureFlagState}/>} />
          <Route path="gold-rates-create" element={<GoldRatesCreate  classes={classes} featureFlagState={featureFlagState}/>} />
          <Route path="silverRate" element={<SilverMaster featureFlagState={featureFlagState}/>} />
          <Route path="silverRateCreate" element={<SilverMasterCreate  classes={classes} featureFlagState={featureFlagState}/>} />
          <Route path="state" element={<StateMaster />} />
          <Route path="state-create" element={<StateMasterCreate  classes={classes}/>} />
          <Route path="state-create/:stateCode" element={<StateMasterCreate  classes={classes}/>} />
          <Route path="branches" element={<Branches />} />
          <Route path="branch-create" element={<BranchCreate classes={classes}/>} />
          <Route path="branch-create/:branchId" element={<BranchCreate  classes={classes}/>} />
          <Route path="branch-view/:branchId" element={<BranchCreate  classes={classes}/>} />
          <Route path="pincodes" element={<Pincodes />} />
          <Route path="pincode-create" element={<PincodeCreate  classes={classes}/>} />
          <Route path="pincode-create/:id" element={<PincodeCreate  classes={classes}/>} />
          <Route path="roles" element={<Roles />} />
          <Route path="role-create" element={<RoleCreate  classes={classes}/>} />
          <Route path="role-create/:roleId" element={<RoleCreate  classes={classes}/>} />
          <Route path="structure" element={<Structure />} />
          <Route path="structure-create" element={<StructureCreate  classes={classes}/>} />
          <Route path="structure-create/:typeId" element={<StructureCreate  classes={classes} />} />
          <Route path="hierarchy" element={<Hierarchy />} />
          <Route path="hierarchy-create" element={<HierarchyCreate  classes={classes}/>} />
          <Route path="hierarchy-create/:hierarchyId" element={<HierarchyCreate  classes={classes}/>} />
          <Route path="hierarchy-createview/:hierarchyId" element={<HierarchyCreate  classes={classes}/>} />
          <Route path="user-roles" element={<User />} />
          <Route path="user-roles-invite" element={<UserInvite classes={classes}/>} />
          <Route path="user-roles-invite/:id" element={<UserInvite classes={classes}/>} />
          <Route path="user-roles-invite-createview/:id" element={<UserInvite classes={classes}/>} />
          <Route path="loanScheme" element={<Scheme featureFlag={featureFlagState}/>} />
          <Route path="loanSchemecreate" element={<SchemeCreate classes={classes}/>} />
          <Route path="loanScheme-createview/:code" element={<SchemeCreate classes={classes}/>} />
          <Route path="loanSchemecreate/:code" element={<SchemeCreate classes={classes} />} />
          <Route path="ornament" element={<Ornament classes={classes}/>} />
          <Route path="ornament-create" element={<OrnamentCreate classes={classes} featureFlag={featureFlagState}/>} />
          <Route path="ornament-create/:ornamentId" element={<OrnamentCreate classes={classes} featureFlag={featureFlagState}/>} />
          <Route path="StandardDeduction" element={<StandardDeduction classes={classes}/>} />
          <Route path="StandardDeduction-create" element={<StandardDeductionCreate classes={classes}/>} />
          <Route path="StandardDeduction-create/:deductionId" element={<StandardDeductionCreate classes={classes}/>} />
          <Route path="NoticeBoard" element={<NoticeBoard classes={classes}/>} />
          <Route path="NoticeBoard-create" element={<NoticeBoardCreate classes={classes}/>} />
          <Route path="NoticeBoard-create/:noticeBoardId" element={<NoticeBoardCreate classes={classes}/>} />
          <Route path="RegisterMaster" element={<Register classes={classes}/>} />
          <Route path="RegisterMaster-create" element={<RegisterCreate classes={classes}/>} />
          <Route path="RegisterMaster-create/:RegisterMasterId" element={<RegisterCreate classes={classes}/>} />
          <Route path="PacketInventory" element={<PacketInventory classesChild={classes} featureFlagState={featureFlagState}/>} />
          <Route path="Lender" element={<Lender classes={classes}/>} />
          <Route path="Lender-create" element={<LenderCreate classes={classes}/>} />
          <Route path="Lender-create/:LenderId" element={<LenderCreate classes={classes}/>} />
          <Route path="BlackListPinCodes" element={<BlackListPinCodes />} />
          <Route path="BlackListPinCode-create" element={<BlackListPinCodesCreate  classes={classes}/>} />
          <Route path="BlackListPinCode-create/:id" element={<BlackListPinCodesCreate  classes={classes}/>} />
          <Route path="relationship" element={<RelationShipMaster />} />
          <Route path="relationship-create" element={<RelationShipMasterCreate  classes={classes}/>} />
          <Route path="relationship-create/:id" element={<RelationShipMasterCreate  classes={classes}/>} />
          <Route path="DueDiligence" element={<NegativeProfileMaster />} />
          <Route path="DueDiligence-create" element={<NegativeProfileMasterCreate  classes={classes}/>} />
          <Route path="DueDiligence-create/:id" element={<NegativeProfileMasterCreate  classes={classes}/>} />
          <Route path="NegativeRegistery" element={<NegativeRegisteryMaster />} />
          <Route path="NegativeRegistery-create" element={<NegativeRegisteryMasterCreate  classes={classes}/>} />
          <Route path="NegativeRegistery-create/:id" element={<NegativeRegisteryMasterCreate  classes={classes}/>} />
          <Route path="Discrepancy" element={<DiscrepancyMaster />} />
          <Route path="Discrepancy-create" element={<DiscrepancyMasterCreate  classes={classes}/>} />
          <Route path="Discrepancy-create/:id" element={<DiscrepancyMasterCreate  classes={classes}/>} />
          <Route path="Collateral" element={<CollateralEvaluationMaster />} />
          <Route path="Collateral-create" element={<CollateralEvaluationMasterCreate  classes={classes}/>} />
          <Route path="Collateral-create/:id" element={<CollateralEvaluationMasterCreate  classes={classes}/>} />
          <Route path="Collateral-createView/:id" element={<CollateralEvaluationMasterCreate  classes={classes}/>} />
          <Route path="riskCategoryTab" element={<RiskCategoryTab />} />
          <Route path="riskCategory" element={<RiskCategoryMaster />} />
          <Route path="riskCategory-create" element={<RiskCategoryMasterCreate  classes={classes}/>} />
          <Route path="riskCategory-create/:id" element={<RiskCategoryMasterCreate  classes={classes}/>} />
          <Route path="riskCategory-createView/:id" element={<RiskCategoryMasterCreate  classes={classes}/>} />
          <Route path="riskCategoryScore" element={<RiskCategoryScoreMaster />} />
          <Route path="riskCategoryScore-create" element={<RiskCategoryScoreMasterCreate  classes={classes}/>} />
          <Route path="riskCategoryScore-create/:id" element={<RiskCategoryScoreMasterCreate  classes={classes}/>} />
          <Route path="riskCategoryScore-createView/:id" element={<RiskCategoryScoreMasterCreate  classes={classes}/>} />
          <Route path="riskWeightage-create" element={<RiskWeightageCreate  classes={classes}/>} />
          <Route path="riskWeightage-create/:id" element={<RiskWeightageCreate  classes={classes}/>} />
          <Route path="riskWeightage-createView/:id" element={<RiskWeightageCreate  classes={classes}/>} />
          <Route path="RuleEngine" element={<RuleEngineWeighage  classesChild={classes}/>} />
          <Route path="InsuranceEligibility" element={<InsuredEligibility  classes={classes}/>} />
          <Route path="InsuranceEligibility-create" element={<InsuredEligibilityCreate  classes={classes}/>} />
          <Route path="suminsured" element={<SumInsured  classesChild={classes}/>} />
          <Route path="SumInsured-create" element={<SumInsuredCreate  classes={classes}/>}/>
          <Route path="ThirdParty" element={<ThirdParty />} />
          <Route path="ThirdParty-create" element={<ThirdPartyCreate  classes={classes}/>} />
          <Route path="ThirdParty-create/:id" element={<ThirdPartyCreate  classes={classes}/>} />
          <Route path="Holiday" element={<HolidayMaster />} />
          <Route path="Holiday-create" element={<HolidayMasterCreate  classes={classes}/>} />
          <Route path="GLHead" element={<GlHeadMaster classes={classes}/>} />
          <Route path="GLHead-create" element={<GlHeadCreate  classes={classes}/>} />
          <Route path="GLHead-edit" element={<GlHeadEdit  classes={classes}/>} />
          <Route path="WhiteListIP" element={<WhiteListIPMaster classes={classes}/>} />
          <Route path="WhiteListIP-create" element={<WhiteListIPMasterCreate  classes={classes}/>} />
          <Route path="WhiteListIP-create/:id" element={<WhiteListIPMasterCreate  classes={classes}/>} />
          <Route path="AccessRestriction" element={<AccessRestrictionTabs classes={classes}/>} />
          <Route path="lendingpartner" element={<Partner classes={classes}/>} />
          <Route path="lendingpartner-create" element={<PartnerCreate classes={classes}/>} />
          <Route path="lendingpartner-create/:partnerId" element={<PartnerCreate classes={classes}/>} />
          <Route path="partnerDeal/:code/:name/:id" element={<PartnerDeal classes={classes}/>} />
          <Route path="partnerDeal-create/:code/:name/:id" element={<PartnerDealCreate classes={classes}/>} />
          <Route path="partnerDeal-create/:partnerId/:code/:name/:id" element={<PartnerDealCreate classes={classes}/>} />
          <Route path="partnerDealShare/:code" element={<PartnerDealShare classes={classes}/>} />
          <Route path="partnerDealShare-create/:code" element={<PartnerDealShareCreate classes={classes}/>} />
          <Route path="partnerDealShare-create/:partnerId/:code" element={<PartnerDealShareCreate classes={classes}/>} />
          <Route path="RenewalTopUpValidation" element={<RenewalTopUpValidation />} />
          <Route path="RenewalTopUpValidation-create" element={<RenewalTopUpValidationCreate  classes={classes}/>} />
          <Route path="RenewalTopUpValidation-create/:id" element={<RenewalTopUpValidationCreate  classes={classes}/>} />
          <Route path="designation" element={<Designation />} />
          <Route path="designation-create" element={<DesignationCreate  classes={classes}/>} />
          <Route path="designation-create/:id" element={<DesignationCreate  classes={classes}/>} />
          <Route path="deviation" element={<Deviation classes={classes}/>} />
          <Route path="deviation-create" element={<DeviationCreate classes={classes}/>} />
          <Route path="deviation/:id" element={<DeviationCreate classes={classes}/>} />
          <Route path="deviation-createview/:id" element={<DeviationCreate classes={classes}/>} />
          <Route path="leadValidation" element={<LeadValidation classes={classes}/>} />
          <Route path="leadValidation-create" element={<LeadValidationCreate classes={classes}/>} />
          <Route path="leadValidation/:id" element={<LeadValidationCreate classes={classes}/>} />
          <Route path="MasterCategory" element={<MasterCategory classesChild={classes} featureFlagState={featureFlagState}/>} />
          <Route path="MasterCategory-create" element={<MasterCategoryCreate classes={classes} featureFlagState={featureFlagState}/>} />
          <Route path="MasterCategory-create/:id" element={<MasterCategoryCreate classes={classes} featureFlagState={featureFlagState}/>} />
          <Route path="MasterItem/:name/:id" element={<MasterItem classes={classes} featureFlagState={featureFlagState}/>} />
          <Route path="MasterItem-create/:name/:categoryId" element={<MasterItemCreate classes={classes} featureFlagState={featureFlagState}/>} />
          <Route path="MasterItem-create/:name/:categoryId/:id" element={<MasterItemCreate classes={classes} featureFlagState={featureFlagState}/>} />
          <Route path="foirConfig" element={<FoirConfig classes={classes}/>} />
          <Route path="foirConfigCreate" element={<FoirConfigCreate classes={classes}/>} />
          <Route path="foirConfigCreate/:foirId" element={<FoirConfigCreate classes={classes}/>} />
          <Route path="diamondMaster" element={<DiamondMaster classes={classes}/>} />
          <Route path="diamondMasterCreate" element={<DiamondMasterCreate classes={classes}/>} />
          <Route path="diamondMasterCreate/:id" element={<DiamondMasterCreate classes={classes}/>} />
        </Route>
        <Route path="*" element={<Navigate to="/coreservice/dashboard" />} />
      </Routes>
    </BrowserRouter>
  );
}
export default withStyles(style)(App)
